import React from "react";
import { Link } from "react-router-dom";
import { Clock, MapPin, ArrowRight, Utensils, MoonStar, Users } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useReveal } from "../hooks/useReveal";
import { PageBanner, SectionHeader } from "../components/Shared";
import { useContent } from "../context/ContentContext";

const HalalTours = () => {
  const { t, lang } = useLang();
  const { HALAL_TOURS, IMAGES } = useContent();
  useReveal([lang]);

  const perks = [
    { icon: Utensils, en: "Halal Dining", bn: "হালাল খাবার" },
    { icon: MoonStar, en: "Prayer Facilities", bn: "নামাজের সুবিধা" },
    { icon: Users, en: "Family Friendly", bn: "পরিবার-বান্ধব" },
  ];

  return (
    <div>
      <PageBanner title={t.sec.halal_title} subtitle={t.sec.halal_sub} image={HALAL_TOURS[0].image} />

      <section className="py-10 bg-white border-b border-jannah-sand">
        <div className="max-w-4xl mx-auto px-6 grid grid-cols-3 gap-4">
          {perks.map((p, i) => {
            const Icon = p.icon;
            return (
              <div key={i} className="flex flex-col items-center gap-2 text-center">
                <div className="w-12 h-12 rounded-full bg-jannah-green/10 flex items-center justify-center">
                  <Icon className="text-jannah-green" size={22} />
                </div>
                <span className="text-sm font-semibold text-jannah-green-dark">
                  {lang === "en" ? p.en : p.bn}
                </span>
              </div>
            );
          })}
        </div>
      </section>

      <section className="section-pad bg-jannah-cream">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {HALAL_TOURS.map((tour) => (
              <div key={tour.id} className="reveal card-hover bg-white rounded-2xl overflow-hidden border border-jannah-sand flex flex-col">
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={tour.image}
                    alt={lang === "en" ? tour.name_en : tour.name_bn}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <span className="absolute top-4 right-4 px-3 py-1 rounded-full btn-gold text-xs font-bold">
                    ${tour.price}
                  </span>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h3 className="text-2xl font-bold text-jannah-green-dark">
                    {lang === "en" ? tour.name_en : tour.name_bn}
                  </h3>
                  <p className="mt-2 text-sm text-muted-foreground flex-1">
                    {lang === "en" ? tour.desc_en : tour.desc_bn}
                  </p>
                  <div className="mt-4 flex items-center gap-4 text-sm text-jannah-green-dark/70">
                    <span className="flex items-center gap-1.5"><Clock size={15} className="text-jannah-gold" /> {tour.duration} {t.days}</span>
                    <span className="flex items-center gap-1.5"><MapPin size={15} className="text-jannah-gold" /> {lang === "en" ? "Guided" : "গাইডেড"}</span>
                  </div>
                  <Link
                    to="/customize"
                    className="mt-5 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-jannah-green text-white font-semibold hover:bg-jannah-green-dark"
                  >
                    {t.enquire} <ArrowRight size={16} />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-jannah-green py-16">
        <div className="max-w-3xl mx-auto px-6 text-center text-white">
          <SectionHeader eyebrow={t.sec.halal_eye} title={t.cta.title} light />
          <Link to="/customize" className="inline-flex items-center gap-2 px-8 py-4 rounded-full btn-gold font-semibold">
            {t.cta.btn} <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HalalTours;
